import React from "react"
import Icon from "../../Icon/Icon"
import Button from "../../Button/Button"
import {JWTProviders} from "../../../resources/orgSettings"
import {useModal} from "react-modal-hook"
import {JwksInfoModal} from "../JwksInfoModal/JwksInfoModal"
import * as Yup from "yup"
import TextField from "../TextField/TextField"

const jwksPathSchema = Yup.string()
	.required("JWKS path is required")
	.matches(
		/^https:\/\/([A-Za-z0-9\-]+\.)+okta\.com\/oauth2\/[A-Za-z0-9]+\/v1\/keys$/,
		"Invalid url, make sure your url is in this format: 'https://{oktaDomain}/oauth2/{authorization_server_id}/v1/keys'"
	)

const jwtIssuerSchema = Yup.string().required("JWT Issuer is required")

export default function OktaFields() {
	const [showJwksInfoModal, hideJwksInfoModal] = useModal(() => (
		<JwksInfoModal close={hideJwksInfoModal} provider={JWTProviders.Okta} />
	))

	return (
		<fieldset className="fields">
			<TextField
				name="jwksPath"
				label="JWKS Path"
				placeholder="Your JWKS Key"
				validationSchema={jwksPathSchema}
				helpElements={
					<>
						<Icon
							icon="information-circle--interface-essential"
							size={12}
							data-tip="React-tooltip"
							data-for="jwks-path-tooltip"
						/>
						<Button type="button" className="jwks-button" onClick={showJwksInfoModal}>
							How to find my JWKS
						</Button>
					</>
				}
			/>
			<TextField name="jwtIssuer" label="JWT Issuer" placeholder="Issuer" validationSchema={jwtIssuerSchema} />
		</fieldset>
	)
}
